import styled from 'styled-components'

export const Toolbar = styled.div`
  display: grid;
  flex-flow: row;
  margin-bottom: 8px;
  grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr);`};
  column-gap: 1%;
`
export const ToolbarItem = styled.div`
  margin-right: 1rem;
  width: 100%;
  justify-content: ${({ last }) => `${last ? 'flex-end' : 'flex-start'}`};
`
